export default __webpack_public_path__ + "img/like-vote.6c8a8dc.svg";